'use strict';

/* global jQuery */
/* global require */
const util = require('util');
angular
  .module('pushNotification')
  .component('pushNotification', {
    template: require('./push-notification.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function SentencesViewController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'notices';
        $rootScope.menu = 'pushNotification';
        const APIURL = envService.read('apiUrl'); // eslint-disable-line

        this.userSearch = { query: '', result: [] };
        this.pushRequest = { USERS: [], MESSAGE: '' };
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }

        $resource(`${APIURL}/admin/sentences`)
          .get()
          .$promise
          .then((data) => {
            this.sentences = data.sentences;
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });

        this.searchUsers = () => {
          console.log(`searchUsers() - query=${this.userSearch.query}`);
          if (this.userSearch.query.length < 3) {
            return;
          }
          const selectedUser = this.userSearch.result.find(user => (`${user.NAME} : ${user.EMAIL}(${user.TEL})`) === this.userSearch.query);
          if (selectedUser) {
            if (this.pushRequest.USERS.filter(e => e.ID === selectedUser.ID).length < 1) {
              this.pushRequest.USERS.push(selectedUser);
            }
            this.userSearch.query = '';
            this.userSearch.result = [];
            return;
          }
          $resource(`${APIURL}/admin/users`).get({ q: this.userSearch.query, count: -1 }, (data) => {
            console.log(`users count=${data.users.length}`);
            this.userSearch.result = data.users;
          }, err => this.alertError(err));
        };

        this.unselectUser = (user) => {
          const unselectedEmployeeIdx = this.pushRequest.USERS.indexOf(user);
          if (unselectedEmployeeIdx > -1) {
            console.log(`unselectedEmployeeIdx=${unselectedEmployeeIdx}`);
            this.pushRequest.USERS.splice(unselectedEmployeeIdx, 1);
            this.userSearch.result = [];
          }
        };

        this.submit = () => {
          console.log(`submit() - pushRequest=${JSON.stringify(this.pushRequest)}`);

          if (!this.pushRequest.MESSAGE) {
            alert(util.format($translate.instant('%s를(을) 입력해주세요.'), $translate.instant('몌시지')));
            return;
          }
          if (!this.pushRequest.USERS || this.pushRequest.USERS.length < 1) {
            alert(util.format($translate.instant('%s를(을) 입력해주세요.'), $translate.instant('사용자')));
            return;
          }
          const strUrl = `${APIURL}/admin/push`;
          this.pushRequest.USER_IDS = this.pushRequest.USERS.map(u => u.ID);
          this.pushRequest.USERS = [];
          $resource(strUrl)
            .save(this.pushRequest)
            .$promise
            .then((res) => {
              console.log(`res=${JSON.stringify(res)}`);
              if (res.msg) {
                alert(res.msg);
              } else {
                this.pushRequest.USERS = [];
                this.pushRequest.MESSAGE = '';
                alert($translate.instant('푸시 전송 완료'));
              }
            })
            .catch((err) => { this.alertError(err); });
        };

        this.alertError = (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/boards/push-notification/push-notification.component.js